module.exports = __webpack_public_path__ + "img/china.2512d4ee.jpg";